export default __webpack_public_path__ + "static/media/policy_popup_background.eb2a4867.png";